<template>
    <div class="p-3 bg-dark">
        <div class="row">
            <div class="col-md-12">
                <h5>{{transEdit('queue-for-time')}}</h5>
                <hr class="hr-grey">
                <div class="h6 font-weight-bold">{{getDateTime(schedule.start)}}</div>
                <div class="text-muted">{{schedule.location.name}} {{schedule.location.city ? schedule.location.city.name : ''}}</div>
                <div class="text-muted"><img class="round-profile-picture" :src="'/therapist_profile_picture/'+schedule.therapist.profile_picture_path"> {{schedule.therapist.user.name}}</div>
                <div class="mt-3"><strong>{{transEdit('treatments')}}:</strong></div>
                <ul>
                    <li v-for="treatment in schedule.treatments">{{treatment.name}}</li>
                </ul>
                <hr class="hr-grey">
                <div>
                    <strong>{{transEdit('how-queues-work')}}</strong>
                    <div>
                        <span>{{transEdit('queue-explanation')}}</span>
                    </div>
                </div>
                <hr class="hr-grey">
                <template v-if="! user_id">
                    <div>{{transEdit('queue-not-signed-in')}}</div>
                    <hr class="hr-grey">
                </template>
                <div class="py-3">
                    <button class="rounded btn-primary-dark px-8 py-2" @click="addToQueue" :disabled="! user_id"><i class="fa fa-check"></i> {{transEdit('put-in-queue')}}</button>
                    <button class="blue bg-transparent text-red-500 px-8 py-2 cursor-default" @click="closeModal"><i class="fa fa-ban"></i> {{transEdit('cancel')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Vue from 'vue';
    export default {
        name: "QueueModal",
        props: ['schedule', 'treatment_id', 'user_id'],
        methods: {
            getDateTime(dateString){
                return moment(dateString).format('YYYY-MM-DD') + ' kl. ' +  moment(dateString).format('HH:mm')
            },
            getTime(dateString){
                return moment(dateString).format('HH:mm')
            },
            addToQueue(){
                axios.post('/queue', {
                    'schedule_id': this.schedule.id,
                    'treatment_id': this.treatment_id,
                }).then((res) => {
                    if(res.data.success) {
                        Vue.toasted.success(res.data.info_string);
                        this.$eventHub.$emit('newQueueList', res.data.queues);
                        this.$emit('close');
                    } else {
                        Vue.toasted.error(res.data.info_string);
                    }
                });
            },
            closeModal() {
                this.$emit('close');
            }
        }
    }
</script>

<style scoped>
    .round-profile-picture {
        height: 28px;
        width: auto;
        max-width: 28px;
        border-radius: 50px;
        border: 2px solid rgba(0,0,0,0.1);
    }
    .hr-grey {
        margin: 15px 0;
        border-color: rgb(83, 83, 83);
    }

    .btn-primary-dark:disabled {
        background-color: darkblue;
        color: lightgrey;
        cursor: not-allowed;
    }
</style>
